module.exports = ".titleTree{color:#0076c2;margin-bottom:8px}\n"